import { connect } from 'react-redux';
import clone from 'lodash/cloneDeep';
import View from './ChildrenCRUDView';
import {
  currentClientId,
  isPopulatedSelector,
  iterator,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import childrenSelector, {
  isEmptyStateSelector,
  viewIDSelector,
  nextIteratorsSelector,
} from './ChildrenCRUDSelector';
import { filterDependents } from '../helpers/filterDependents';
import dirtyNodesMapSelector from '../../AdvWorkflow/AdvWorkflowCacheSelector';
import {
  updateData,
  updateSupportData,
  updateValidation,
} from '../../AdvWorkflow/AdvWorkflowActions';
import { getSelectedChildFirstName, getEducationGoalList } from '../ChildrenInfoWorkflowSelector';
import {
  BACKEND_KEY,
  DEFAULT_CHILD,
  CHILDREN_CRUD_ADD_EDIT,
} from '../../PersonalInfoWorkflow/PersonalInfoWorkflowConstants';
import { fetchDataIfNecessary } from '../../AdvWorkflow/AdvWorkflowCacheActions';
import { buildMutation } from '../../AdvWorkflow/AdvWorkflowHelpers';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  children: childrenSelector(state, ownProps),
  isEmptyState: isEmptyStateSelector(state, ownProps),
  viewID: viewIDSelector(state, ownProps),
  selectedChildFirstName: getSelectedChildFirstName(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
  nextIterators: nextIteratorsSelector(state, ownProps),
  educationGoals: getEducationGoalList(state, ownProps),
  iterator: iterator(state, ownProps),
  dirtyNodesMap: dirtyNodesMapSelector(state),
});
const mapDispatchToProps = dispatch => ({
  onSelectChild: (
    workflowId,
    clientId,
    goals,
    selectedChildFirstName,
    newSelectedChildFirstName,
    validationId,
  ) => () => {
    dispatch(updateValidation(buildMutation(validationId, []), workflowId, clientId));
    // if we had a goal selected before, we overwrite the childName for that goal
    // If the new child name is already found in the goal list we remove that goal from
    // the list
    let updatedGoalID = null;
    let newEducationGoals = goals.map(goal => {
      if (goal.Name === selectedChildFirstName) {
        updatedGoalID = goal.Id;
        return {
          ...goal,
          Name: newSelectedChildFirstName,
        };
      }
      return goal;
    });
    if (updatedGoalID !== null) {
      newEducationGoals = newEducationGoals.filter(
        educationGoal =>
          educationGoal.Id === updatedGoalID || educationGoal.Name !== newSelectedChildFirstName,
      );
    }

    dispatch(
      updateData(
        {
          EducationGoals: newEducationGoals,
        },
        workflowId,
      ),
    );
    dispatch(
      updateSupportData(
        {
          [BACKEND_KEY]: {
            SelectedChildFirstName: newSelectedChildFirstName,
          },
        },
        workflowId,
        clientId,
      ),
    );
  },
  onPostSave: (store2, clientId) => data => {
    const deps = (data.PersonalInfo && data.PersonalInfo.Dependents) || [];
    store2(
      {
        [BACKEND_KEY]: {
          HasChildren: filterDependents(deps).length !== 0,
        },
      },
      clientId,
    );
  },
  onRemoveChild: (children, store, index, clientId) => event => {
    event.preventDefault();
    event.stopPropagation();
    store(
      {
        [BACKEND_KEY]: {
          Dependents: [...children.slice(0, index), ...children.slice(index + 1)],
        },
      },
      clientId,
    );
  },
  onAddChild: (children, store, store2, clientId, workflowId, validationId) => event => {
    dispatch(updateValidation(buildMutation(validationId, []), workflowId, clientId));

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    store(
      {
        [BACKEND_KEY]: {
          Dependents: [...children, clone(DEFAULT_CHILD)],
        },
      },
      clientId,
    );
    store2(
      {
        [BACKEND_KEY]: {
          ChildrenStepViewID: CHILDREN_CRUD_ADD_EDIT,
          ChildrenStepIndex: children.length,
          ChildrenStepIsEdit: false,
        },
      },
      clientId,
    );
  },
  onEditChild: (children, store, store2, index, clientId) => event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    store2(
      {
        [BACKEND_KEY]: {
          ChildrenStepViewID: CHILDREN_CRUD_ADD_EDIT,
          ChildrenStepIndex: index,
          ChildrenStepIsEdit: true,
        },
      },
      clientId,
    );
  },
  childInputChanged: (children, store, index, fieldName, clientId) => event => {
    store(
      {
        [BACKEND_KEY]: {
          Dependents: [
            ...children.slice(0, index),
            {
              ...children[index],
              [fieldName]: event.target.value,
            },
            ...children.slice(index + 1),
          ],
        },
      },
      clientId,
    );
  },
  store: workflowId => (data, clientId) => dispatch(updateData(data, workflowId, clientId)),
  store2: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
  fetchData: (workflowId, clientId, dirtyNodesMap) => {
    dispatch(fetchDataIfNecessary(workflowId, clientId, ['EducationGoals'], dirtyNodesMap, false));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
